import * as React from 'react';
import { styled } from '@mui/material/styles';
import { AppBar, ToggleThemeButton, defaultTheme } from 'react-admin';
import Typography from '@mui/material/Typography';
import Avatar from '@mui/material/Avatar'
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
//import createTheme from '@mui/material/createTheme';
import { createTheme } from '@mui/material'
//----Icons----
import NotificationsIcon from '@mui/icons-material/Notifications';
import SearchIcon from '@mui/icons-material/Search';

// import hnaklogo from '../../static/assets/shababuna_logo.png';
import LogoWhite from '../../static/assets/LogoWhite.png';

import globalStyles from '../../utils/globalStyles'


const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

const darkTheme = createTheme({
  palette: { mode: 'dark' }
})

const switchPortal = (val) => {
  alert(`You will now be redirected to ${val} portal`)
}



const MainAppBar = (props) => (
  <AppBar sx={{ 
    backgroundColor: globalStyles.colors.backgroundPrimary,
    '& .MuiSelect-icon': { color: globalStyles.colors.white },
    '& .MuiSelect-select': { marginTop: '-15px', border: 'none' },
    // '& .RaAppBar-menuButton': { display: 'none !important' },
    '& .RaAppBar-toolbar .css-1ghzyfa-RaLoadingIndicator-root': { display: 'none !important' },
    '& .RaAppBar-toolbar .css-jp2pjq-RaUserMenu-root':{width:'100%',textAlign:'right'},
    justifyContent: 'space-between',
   
    }}>
    <Box sx={{ marginLeft: '20px', width:'160px' }}>
     {/* <Avatar src={hnaklogo} alt='HNAK logo main' shape='square' sx={{ height: '63px', width: '63px' }} className='home-logo'/> */}
     <img src={LogoWhite} alt='HNAK logo main' shape='square' sx={{ height: '63px', width: '63px' }} className='home-logo' style={{width:"75px", marginTop:"7px", marginBottom:"7px", marginLeft:'10px'}}/>
  </Box>

  {/* <div className='container-fluid'>
    <div className='row'>
      <div className='col-lg-12'>
         <img src={LogoWhite} alt='HNAK logo main' shape='square' sx={{ height: '63px', width: '63px' }} className='home-logo' style={{width:"75px", marginTop:"7px", marginBottom:"7px"}}/>
      </div>
    </div>
  </div> */}
    
{/*    <Box sx={{ minWidth: '52vw' }}>
      <TextField 
        fullWidth label='Enter your keywords' id="fullWidth" 
        type='search' margin='dense'
        sx={{ 
          backgroundColor: '#fff', 
          border: 'none', 
          borderRadius: '50px',
          height: '40px',
          '& .MuiInputLabel-root': {
            color: globalStyles.colors.black,
            marginTop: '-5px'
          },
          visibility: 'hidden' 
        }}
        disabled={true}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <SearchIcon/>
            </InputAdornment>
          )
        }}
        />
      </Box>*/}
   
  </AppBar>
);

export default MainAppBar;